import styled from 'styled-components';
import IconButton from '../../buttons/IconButton';

export const StyledIcon = styled(IconButton)`
  position: relative;
  top: -11px;
  right: -12px;
  margin-left: -24px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;
